import moment from 'moment-timezone';

const HALF_DAY_FORMAT = 'hh:mm A, DD MMM YYYY';
const FULL_DAY_FORMAT = 'HH:mm, DD MMM YYYY';
const MSD_FORMAT = 'hh:mm A, DD/MM/YYYY';

export const is12HourFormat = time =>
  time.indexOf('AM') !== -1 || time.indexOf('PM') !== -1;

const momentInTimeZone = (time, city) => {
  const parsingFormat = is12HourFormat(time)
    ? HALF_DAY_FORMAT
    : FULL_DAY_FORMAT;
  // TO-DO: remove [city.timeZone] after fully roll out to get city details from GrabX
  return moment.utc(time, parsingFormat).tz(city.timeZone || city.timezone);
};

export const renderTimeZone = (time, city) =>
  momentInTimeZone(time, city).format(
    is12HourFormat(time) ? HALF_DAY_FORMAT : FULL_DAY_FORMAT,
  );

export const renderTimeZoneByMinutes = (time, city) =>
  momentInTimeZone(time, city).format(
    is12HourFormat(time) ? 'hh:mm A' : 'HH:mm',
  );

export const renderTimeZoneMSDStyle = (time, city) =>
  momentInTimeZone(time, city).format(MSD_FORMAT);

export const convertTimeZoneUnix = (is12Hour, city, timeStamp) =>
  moment
    .unix(timeStamp)
    .tz(city.timeZone || city.timezone)
    .format(is12Hour ? HALF_DAY_FORMAT : FULL_DAY_FORMAT);
